
      function getAbsoluteUrl(relativeUrl) {
        const publicPath = __webpack_public_path__;

        let url = '';

        if (!publicPath || publicPath.indexOf('://') < 0) {
          url += window.location.protocol + '//' + window.location.host;
        }

        if (publicPath) {
          url += publicPath;
        } else {
          url += '/';
        }

        return url + relativeUrl;
      }
// Copyright 2017-2022 @polkadot/util-crypto authors & contributors
// SPDX-License-Identifier: Apache-2.0
// Do not edit, auto-generated by @polkadot/dev
export const packageInfo = {
  name: '@polkadot/util-crypto',
  path: (({ url: getAbsoluteUrl('util-crypto@8.5.1/node_modules/@polkadot/util-crypto/packageInfo.js') }) && ({ url: getAbsoluteUrl('util-crypto@8.5.1/node_modules/@polkadot/util-crypto/packageInfo.js') }).url) ? new URL('.', ({ url: getAbsoluteUrl('util-crypto@8.5.1/node_modules/@polkadot/util-crypto/packageInfo.js') }).url).pathname : 'auto',
  type: 'esm',
  version: '8.5.1'
};